import React from "react";
import "./SocialMediaBar.scss";
import { links } from "../../SocialMediaData";

const SocialMediaBar = () => {
  return (
    <div className="socialMediaBar">
      <ul>
        {links.map((link, id) => {
          return (
            <li key={id}>
              <a href={link.link} target="_blank" rel="noreferrer">
                {link.icon}
              </a>
            </li>
          );
        })}
        <div className="line"></div>
      </ul>
    </div>
  );
};

export default SocialMediaBar;
